import React from "react";
import { motion } from "framer-motion";
import "./SecurePayment.css";
import { FaBolt, FaLock, FaWallet, FaCogs, FaRocket } from "react-icons/fa";

const features = [
  {
    icon: <FaRocket />,
    title: "Innovation",
    desc: "We constantly evolve with the latest fintech trends, ensuring our platform delivers future-ready solutions with smart automation and AI-driven insights.",
  },
  {
    icon: <FaCogs />,
    title: "Integration",
    desc: "Easily integrate our payment APIs with e-commerce, banking apps, and ERP systems — reducing development time and boosting productivity.",
  },
  {
    icon: <FaLock />,
    title: "Security",
    desc: "With 256-bit encryption, tokenization, and multi-factor authentication, your data stays protected at every step of the transaction lifecycle.",
  },
  {
    icon: <FaBolt />,
    title: "Speed",
    desc: "Experience instant payment processing with real-time updates and minimal latency — making transactions faster and smarter for your business.",
  },
];

// Animation variants
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.25,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const imageVariants = {
  hidden: { scale: 0.8, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

const SecurePayments = () => {
  return (
    <motion.section
      className="modern-section"
      variants={containerVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.2 }}
    >
      <motion.div
        className="modern-heading"
        variants={cardVariants}
      >
        <h2>🔒 Secure & Smart Payments</h2>
        <p>Experience the future of finance with speed, safety, and innovation.</p>
      </motion.div>

      <div className="modern-grid">
        {features.slice(0, 2).map((item, idx) => (
          <motion.div
            className="modern-card"
            key={idx}
            variants={cardVariants}
            whileHover={{ scale: 1.05, boxShadow: "0 15px 30px rgba(0,0,0,0.2)" }}
          >
            <div className="modern-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
            <a href="#">Learn more →</a>
          </motion.div>
        ))}

        <motion.div
          className="modern-center-img"
          variants={imageVariants}
        >
          <div className="image-card">
            <div className="image-text">
              <h3>Empowering You with the <br /> Best Services We Offer</h3>
            </div>
            <img
              src="/secureimage.png"
              alt="Secure Payment"
              className="secureimage"
            />
          </div>
        </motion.div>

        {features.slice(2).map((item, idx) => (
          <motion.div
            className="modern-card"
            key={idx + 2}
            variants={cardVariants}
            whileHover={{ scale: 1.05, boxShadow: "0 15px 30px rgba(0,0,0,0.2)" }}
          >
            <div className="modern-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
            <a href="#">Learn more →</a>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default SecurePayments;
